import { tempoApi } from '@/lib/api/tempoApi';
import { chunkBy } from '@/lib/utils/common/chunkBy';

const INTEGRATION_ITEMS_BATCH_LIMIT = 50;

export const getIntegrationIdsByItemIds = async ({
  itemIds,
}: {
  itemIds: Set<number>;
}): Promise<Record<number, number>> => {
  if (itemIds.size === 0) return {};

  const chunks = chunkBy(Array.from(itemIds), INTEGRATION_ITEMS_BATCH_LIMIT);

  const allResults: Record<number, number> = {};
  for (const chunk of chunks) {
    const response = await tempoApi().post(
      'api/v1/work-integration/integration-items/by-item-ids',
      {
        json: chunk,
      },
    );
    const chunkResult = await response.json<Record<number, number>>();
    Object.assign(allResults, chunkResult);
  }

  return allResults;
};

export const IntegrationItemsApi = {
  getIntegrationIdsByItemIds,
};
